import ownerTicketsComponent from './owner-tickets.component';

const ownerTicketsModule = angular.module('ownerTickets', [
])
  .component('ownerTickets', ownerTicketsComponent)
  .name;

export default ownerTicketsModule;
